import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-initiativereports',
  templateUrl: './initiativereports.component.html',
  styleUrls: ['./initiativereports.component.scss']
})
export class InitiativereportsComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
